import { render, staticRenderFns } from "./RoleAddAction.vue?vue&type=template&id=349ada7a"
import script from "./RoleAddAction.vue?vue&type=script&lang=js"
export * from "./RoleAddAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports